<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a href="javascript:void(0);">
        <svg _ngcontent-bai-c1="" class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path _ngcontent-bai-c1="" d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline _ngcontent-bai-c1="" points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </a>
    </li>
    <li class="breadcrumb-item active" aria-current="page" translate>Affiliate Marketing</li>
  </ol>
</nav>
<div class="affiliate-program">
  <div class="container">
    <!-- Affiliate Link Section -->
    <div class="row mt-5">
      <div class="col-md-12">
        <h3 class="font-weight-bold" translate>{{ 'Your Affiliate Marketing Link' | translate }}</h3>
        <div class="input-group">
          <input type="text" class="form-control" #affiliateLink id="affiliateLink" [(ngModel)]="affiliateLinkUrl" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" (click)="copyAffiliateLink()">نسخ الرابط</button>
          </div>
        </div>
      </div>
    </div>

    <!-- New Section for Merchant Incomes and Balance -->
    <div class="row text-center mt-5">
      <div class="col-md-4">
        <div class="card interactive-card">
          <div class="card-body">
            <h3 class="card-title" translate>Show Invoices</h3>
            <p class="card-text" translate>Show Invoices of Merchants Registered Through You</p>
            <i class="fas fa-chart-line fa-2x"></i>
          </div>
          <div class="card-footer bg-white">
            <button (click)="openInvoices()" class="badge badge-primary" translate>View Invoices</button>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card interactive-card">
          <div class="card-body">
            <h3 class="card-title" translate>Your Balance</h3>
            <h2 class="card-text">{{ affiliateBalance ?? 0 | number:'1.2-2' }}</h2>
            <i class="fas fa-wallet fa-2x"></i>
          </div>
          <div class="card-footer bg-white">
            <button (click)="withdrawBalance()" class="badge badge-primary" translate>Withdraw Balance</button>&nbsp;
            <button (click)="viewWithdrawHistory()" class="badge badge-secondary" translate>View Withdraw Histories</button>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card interactive-card">
          <div class="card-body">
            <h3 class="card-title" translate>Merchants Count</h3>
            <h2 class="card-text">{{ affiliateMerchantsCount ?? 0 | number:'1.0-0' }}</h2>
            <i class="fas fa-wallet fa-2x"></i>
          </div>
          <div class="card-footer bg-white">
            <button (click)="viewMerchants()" class="badge badge-primary" translate>View Merchants</button>
          </div>
        </div>
      </div>
    </div>

    <!--    -->

    <div class="row text-center my-5">
      <div class="col-md-12">
        <h2 class="font-weight-bold" translate>Affiliate Marketing Program</h2>
        <p translate>Get a commission for every merchant who registers through you</p>
      </div>
    </div>
    <div class="row text-center">
      <div class="col-md-6">
        <h3 class="font-weight-bold" translate>Commission</h3>
        <p translate>Get a commission from the sales and subscriptions of every merchant who registers through you</p>
        <span class="text-primary">5%</span>
      </div>
      <div class="col-md-6">
        <h3 class="font-weight-bold" translate>Payment</h3>
        <p translate>Get your commission after order confirmation</p>
        <span class="text-primary" translate>Monthly</span>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row text-center my-5">
      <div class="col-md-12">
        <h2 class="font-weight-bold" translate>How to benefit from affiliate marketing?</h2>
        <p translate>{{ 'Get' | translate }} <span class='text-primary'>{{ 'many services and advantages' | translate }}</span> {{ 'provided by Paylink at competitive prices' | translate }}</p>
      </div>
    </div>
    <div class="row text-center">
      <div class="col-md-4">
        <h3 class="font-weight-bold" translate>Increase Impact</h3>
        <p translate>Greater impact and trust from viewers and traders</p>
        <span class="text-success">&#x2714;</span>
      </div>
      <div class="col-md-4">
        <h3 class="font-weight-bold" translate>Earn from every merchant who registers</h3>
        <p translate>Every trader earns a Paylink marketer earn</p>
        <span class="text-success">&#x2714;</span>
      </div>
      <div class="col-md-4">
        <h3 class="font-weight-bold" translate>Extra Income</h3>
        <p translate>From home, work, library... Don't take hours of your time</p>
        <span class="text-success">&#x2714;</span>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row text-center my-5">
      <div class="col-md-12">
        <h2 class="font-weight-bold" translate>How does the program work?</h2>
        <p translate>Register now and start affiliate marketing</p>
      </div>
    </div>
    <div class="row text-center">
      <div class="col-md-4">
        <h3 class="font-weight-bold" translate>Register</h3>
        <p translate>Register in Paylink and get your own link</p>
        <span class="text-success">&#x2714;</span>
      </div>
      <div class="col-md-4">
        <h3 class="font-weight-bold" translate>Share</h3>
        <p translate>Share the link with your friends and followers</p>
        <span class="text-success">&#x2714;</span>
      </div>
      <div class="col-md-4">
        <h3 class="font-weight-bold" translate>Earn</h3>
        <p translate>Get a commission for every merchant who registers through you</p>
        <span class="text-success">&#x2714;</span>
      </div>
    </div>
  </div>
</div>
<app-withdraw-dialog [maxAmount]="affiliateBalance" (confirm)="onWithdrawConfirm($event)"></app-withdraw-dialog>
